import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { postUsersData, verifytoken } from '../../../../../../services/ApiCallingUserServices';
import { loaderActions } from '../../../../../../_actions/loader.actions';
import { ClearLocalStorage } from '../../../../../commonClass/Session';
import { formatDateyearmonthday, onlyNumeric } from '../../../../../commonClass/CommonValidation';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { activityRateInventoryOpen } from '../../../../../../_actions/user.action';

const ActivityInventoryModal = (props) => {
    const {
        title,
        isEdit,
        selectedCellDate,
        availabilityDates,
        setOpenModal,
        dayRangeList,
        ActivityBasicInfoId,
        UserId,
        ActivityName
    } = props;

    const dispatch = useDispatch();
    const [closedMessage, setClosedMessage] = useState('');
    const [isSave, setIsSave] = useState(true);
    const [formValue, setFormValue] = useState({
        FromDate: formatDateyearmonthday(selectedCellDate) || "",
        ToDate: formatDateyearmonthday(selectedCellDate) || "",
        FromDateSelect: selectedCellDate || null,
        ToDateSelect: selectedCellDate || null,
        InventoryStock: null,
        OnHold: null,
        Days: 0,
        ActivityBasicInfoId: ActivityBasicInfoId,
        UserId: UserId,
    });
    const [formError, setFormError] = useState({});
    const [apiError, setApiError] = useState('')

    const onChange = (name, value) => {
        setIsSave(false);
        setFormError({});
        setApiError('');
        setFormValue(form => ({ ...form, [name]: value }))
    }

    const handleDateRange = (update, isEdit) => {
        setFormError({});
        setIsSave(false);
        setApiError('');
        if (isEdit) {
            setFormValue(form => ({
                ...form,
                FromDate: formatDateyearmonthday(update),
                FromDateSelect: update,
            }))
        }
        else {
            setFormValue(form => ({
                ...form,
                FromDate: formatDateyearmonthday(update[0]),
                FromDateSelect: update[0],
                ToDate: formatDateyearmonthday(update[1]),
                ToDateSelect: update[1],
            }))
        }
    }

    const openDatePicker = (e) => {
        //open date picker on click date icon 
        document.querySelector("#" + e).click();
    };

    const onClose = () => {
        isSave ? setOpenModal(false) : setClosedMessage(true);
    }

    const YesProceed = (e) => {
        e.preventDefault()
        setOpenModal(false)
        setClosedMessage(false)
    }

    const NoProceed = (e) => {
        e.preventDefault()
        setClosedMessage(false)
    }

    const validateData = () => {
        let status = true;
        let error = {};
        if (isEdit) {
            if (formValue?.FromDateSelect === null) {
                error["FromDateSelect"] = "Date selection is mandatory.";
                status = false;
            }
            if (formValue?.InventoryStock === null && formValue?.FromDateSelect !== null) {
                error["InventoryStock"] = "Input is Mandatory.";
                status = false;
            }

        }
        else {
            if (formValue?.FromDateSelect === null || formValue?.ToDateSelect === null) {
                error["date"] = "Date selection is mandatory";
                status = false;
            }

            if (formValue?.Days <= 0) {
                error["Days"] = "Days selection is Mandatory.";
                status = false;
            }
            if (formValue?.InventoryStock === null) {
                error["InventoryStock"] = "Input is Mandatory.";
                status = false;
            }
        }
        if (formValue?.InventoryStock > 1000 && formValue?.InventoryStock !== null) {
            error["InventoryStock"] = "Cannot exceed more than 1000 inventory.";
            status = false;
        }
        if (formValue?.OnHold > formValue?.InventoryStock && formValue?.OnHold !== null) {
            error["OnHold"] = "Kindly provide a valid On Hold quantity.";
            status = false;
        }
        setFormError(error)

        return status;
    }

    //#region API getchannelmanagerlist
    const getDayInventary = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const dayInventoryDetails = await postUsersData('/master/v1/getactivitymanageinventory', {
                ActivityBasicInfoId: ActivityBasicInfoId,
                FromDate: formatDateyearmonthday(formValue?.FromDateSelect),
                ToDate: formatDateyearmonthday(formValue?.FromDateSelect),
            });

            if (dayInventoryDetails.status) {
                setFormValue((pre) => ({
                    ...pre,
                    InventoryStock: dayInventoryDetails?.data?.[0]?.InventoryStock,
                    OnHold: dayInventoryDetails?.data?.[0]?.BlackOut,
                }))
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    };

    //#region Fetch all API data
    //using Promise.all to run them in parallel
    useEffect(() => {
        const fetchDropDownData = async () => {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();

            if (statusoftoken) {
                try {
                    formValue?.FromDateSelect && await getDayInventary();
                } catch (error) {
                    console.error('Error during fetching data:', error);
                } finally {
                    dispatch(loaderActions.end());
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        };

        isEdit && formValue?.FromDateSelect && fetchDropDownData();
    }, [formValue?.FromDateSelect, isEdit]);


    const updateInventary = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const inventory = await postUsersData('/master/v1/insertupdateactivitymanageinventory',
                {
                    ActivityBasicInfoId: formValue?.ActivityBasicInfoId,
                    ActivityInvDate: formatDateyearmonthday(formValue?.FromDateSelect),
                    InventoryStock: formValue?.InventoryStock,
                    BlackOut: formValue?.OnHold,
                    UserId: formValue?.UserId
                }
            );

            if (inventory.status) {
                setOpenModal(false);
                setFormError({})
                setIsSave(true);
                dispatch({ type: 'ALERTING', message: inventory.message });
                dispatch(activityRateInventoryOpen())
            } else {
                setApiError(inventory.message)
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    };

    const updateBulkInventary = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const bulkInventory = await postUsersData('/master/v1/insertbulkupdateactivitymanageinventory',
                {
                    ActivityBasicInfoId: formValue?.ActivityBasicInfoId,
                    FromDate: formValue?.FromDate,
                    ToDate: formValue?.ToDate,
                    DayRangesId: formValue?.Days,
                    InventoryStock: formValue?.InventoryStock,
                    BlackOut: formValue?.OnHold,
                    UserId: formValue?.UserId,
                },
            );
            if (bulkInventory.status) {
                setOpenModal(false);
                setFormError({})
                setIsSave(true);
                dispatch({ type: 'ALERTING', message: bulkInventory.message });
                dispatch(activityRateInventoryOpen())
            } else {
                setApiError(bulkInventory.message)
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    };

    const handleApply = (e) => {
        e.preventDefault();
        if (validateData()) {
            if (isEdit) {
                updateInventary()
            } else {
                updateBulkInventary()
            }

        }
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center bulk_update_modal_header">
                <div className="bulk_update_modal_title">
                    {title}
                </div>
                <div role='button' onClick={onClose}>
                    <i class="fa-solid fa-xmark"></i>
                </div>
            </div>
            {closedMessage &&
                <div className="text-center pb-3">
                    <span className="text-danger">Unsaved data, do you want to close the window ? </span>
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => YesProceed(e)} > Yes </span>
                    or
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => NoProceed(e)} > No</span>.
                </div>
            }
            <form action="" className='py-2'>

                <div className='row'>
                    {
                        !isEdit &&
                        <div className="col-12 mb-4">
                            <input
                                type='text'
                                className='form-control'
                                name='InventoryStock'
                                id="available-quantity"
                                value={ActivityName}
                                readOnly
                            />
                        </div>
                    }

                    <div className="col-12 mb-4">
                        <div className="row">
                            <div className={`${isEdit ? 'col-12' : 'col-6'} `}>
                                {
                                    isEdit ?
                                        <>
                                            <div className='position-relative'>
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className='form-control'
                                                    id='select-date'
                                                    selected={formValue?.FromDateSelect}
                                                    placeholderText="Select Date"
                                                    autoComplete='off'
                                                    showMonthDropdown
                                                    name='FromDateSelect'
                                                    startDate={formValue?.FromDateSelect}
                                                    onChange={(e) => handleDateRange(e, isEdit)}
                                                    minDate={new Date() < new Date(availabilityDates?.StartDate) ? new Date(availabilityDates?.StartDate) : new Date()}
                                                    maxDate={new Date(availabilityDates?.EndDate)}
                                                />
                                                <span className={`example-custom-input activityinventoryBtn ${selectedCellDate !== null ? 'disableCalBtn' : ''}`}
                                                    onClick={(e) => openDatePicker("select-date")}
                                                ><i className="fa fa-calendar"></i></span>
                                            </div>
                                            {formError?.FromDateSelect && <small className='text-danger text-center mt-2'>{formError?.FromDateSelect}</small>}
                                        </>
                                        :
                                        <>
                                            <div className='position-relative'>
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className='form-control'
                                                    id='select-date'
                                                    selected={formValue?.FromDateSelect}
                                                    placeholderText="Select Date Range"
                                                    selectsRange={true}
                                                    autoComplete='off'
                                                    showMonthDropdown
                                                    startDate={formValue?.FromDateSelect}
                                                    endDate={formValue?.ToDateSelect}
                                                    onChange={(e) => handleDateRange(e, isEdit)}
                                                    minDate={new Date() < new Date(availabilityDates?.StartDate) ? new Date(availabilityDates?.StartDate) : new Date()}
                                                    maxDate={new Date(availabilityDates?.EndDate)}
                                                />
                                                <span className={`example-custom-input activityinventoryBtn ${selectedCellDate !== null ? 'disableCalBtn' : ''}`}
                                                    onClick={(e) => openDatePicker("select-date")}
                                                ><i className="fa fa-calendar"></i></span>
                                            </div>
                                            {formError?.date && <small className='text-danger text-center mt-2'>{formError?.date}</small>}
                                        </>
                                }


                            </div>
                            {
                                !isEdit &&
                                <div className="col-6">
                                    <Select
                                        name='Days'
                                        className="dropdown select_dropdown"
                                        options={dayRangeList}
                                        inputId='select-days'
                                        value={dayRangeList?.find((obj) => obj?.value === formValue?.Days) || null}
                                        onChange={(e) => onChange("Days", e?.value ? e?.value : null)}
                                        isSearchable
                                        placeholder='Days'
                                    />
                                    {formError?.Days && <small className='text-danger text-center mt-2'>{formError?.Days}</small>}
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="row">
                            <div className="col-6">
                                <input
                                    type='text'
                                    className='form-control'
                                    name='InventoryStock'
                                    id="available-quantity"
                                    value={formValue?.InventoryStock}
                                    onChange={(e) => onChange(e.target.name, e.target.value === "" ? null : Number(onlyNumeric(e.target.value)))}
                                    autoComplete='off'
                                    placeholder='Available'
                                    maxLength={4}
                                    disabled={isEdit && !formValue?.FromDateSelect ? true : false}
                                />
                                {formError?.InventoryStock && <small className='text-danger text-center mt-2'>{formError?.InventoryStock}</small>}
                            </div>
                            <div className="col-6">
                                <input
                                    type='text'
                                    className='form-control'
                                    name='OnHold'
                                    id="on-hold"
                                    value={formValue?.OnHold}
                                    onChange={(e) => onChange(e.target.name, e.target.value === "" ? null : Number(onlyNumeric(e.target.value)))}
                                    autoComplete='off'
                                    placeholder='On Hold'
                                    maxLength={4}
                                    disabled={isEdit && !formValue?.FromDateSelect ? true : false}
                                />
                                {formError?.OnHold && <small className='text-danger text-center mt-2'>{formError?.OnHold}</small>}
                            </div>
                        </div>
                    </div>
                    {apiError && <small className='text-danger text-center mt-2'>{apiError}</small>}
                    <div className="col-12 mt-4">
                        <button type="button" className='btn bulk_apply_btn btn-primary w-100' onClick={(e) => handleApply(e)} >Apply</button>
                    </div>
                </div>
            </form>

        </>
    )
}
export default ActivityInventoryModal